import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=059b2eff&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059b2eff')) {
      api.createRecord('059b2eff', component.options)
    } else {
      api.reload('059b2eff', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=059b2eff&", function () {
      api.rerender('059b2eff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DLXNXOl6XX2u/JS/comp/childrenage.vue"
export default component.exports